import React, { useState, useEffect } from 'react';
import Modal from 'rsuite/Modal';
import NewCertificadoForm from 'Components/Admin/Certificado/NewCertificado/NewCertificadoForm';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { requestCertAsync } from 'slices/certSlice';

export default function NewCertificadoModal(props) {
  const {isOpen, setOpen, data} = props;
  const [formData, setFormData] = useState(null);
  const dispatch = useDispatch();

  const handleClose = () => {
    setOpen(false);
    dispatch(requestCertAsync({ pagination: { NumberPage: 1, SizePage: 15 } }));
  }

  useEffect(() => {
    setFormData(data);
  }, [data])

  return (
    <>
      <Modal size="md" open={isOpen} onClose={handleClose} onSuccess={handleClose} backdrop='static'>
        <Modal.Header>
          <Modal.Title>{formData && formData.nit? 'Actualizar': 'Nuevo'} Certificado</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <NewCertificadoForm data={formData} />
        </Modal.Body>
        <Modal.Footer>
        </Modal.Footer>
      </Modal>
    </>
  );
}

NewCertificadoModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  data: PropTypes.object,
}